import { request } from '@umijs/max';

function parseMaybeJson(payload: any) {
  if (typeof payload !== 'string') return payload;
  try {
    return JSON.parse(payload);
  } catch {
    return payload;
  }
}

function unwrapData(payload: any) {
  let raw: any = parseMaybeJson(payload);
  for (let i = 0; i < 3; i += 1) {
    if (raw && typeof raw === 'object' && 'data' in raw) {
      raw = parseMaybeJson((raw as any).data);
      continue;
    }
    break;
  }
  return raw;
}

/** 获取订阅计划列表 */
export async function getPlans(options?: { [key: string]: any }) {
  // Keep consistent with website-end BFF: GET /payment/plans (proxied under /api/* from frontend).
  const res = await request<any>('/api/payment/plans', {
    method: 'GET',
    ...(options || {}),
  });
  return unwrapData(res);
}

/** 充值计算 */
export async function calculateRecharge(
  data: { amount: number; currency?: string },
  options?: { [key: string]: any },
) {
  const res = await request<any>('/api/payment/recharge/calculate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data,
    ...(options || {}),
  });
  return unwrapData(res);
}

/** 创建支付订单 */
export async function createPaymentOrder(
  data: {
    orderType: string;
    paymentMethod: string;
    planCode?: string;
    billingCycle?: string;
    rechargeAmount?: number;
  },
  options?: { [key: string]: any },
) {
  const res = await request<any>('/api/payment/create', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data,
    ...(options || {}),
  });
  return unwrapData(res);
}

/** 初始化支付 SSE 会话 */
export async function initPaymentSseSession(
  data: { orderNo: string; token: string },
  options?: { [key: string]: any },
) {
  const res = await request<any>('/api/payment/sse/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data,
    credentials: 'include',
    ...(options || {}),
  });
  return unwrapData(res);
}

/** 查询支付状态 */
export async function getPaymentStatus(
  orderNo: string,
  options?: { [key: string]: any },
) {
  const res = await request<any>(`/api/payment/status/${orderNo}`, {
    method: 'GET',
    ...(options || {}),
  });
  return unwrapData(res);
}

/** PayPal capture */
export async function capturePayment(
  orderNo: string,
  options?: { [key: string]: any },
) {
  const res = await request<any>(`/api/payment/capture/${orderNo}`, {
    method: 'POST',
    ...(options || {}),
  });
  return unwrapData(res);
}

/** 获取已启用的支付方式 */
export async function getPaymentMethods(options?: { [key: string]: any }) {
  const res = await request<any>('/api/payment/methods', {
    method: 'GET',
    ...(options || {}),
  });
  return unwrapData(res);
}

/** 获取支付订单列表 */
export async function getPaymentOrders(options?: { [key: string]: any }) {
  const res = await request<any>('/api/payment/orders', {
    method: 'GET',
    ...(options || {}),
  });
  return unwrapData(res);
}

/** 获取邀请记录 */
export async function getInviteRecords(options?: { [key: string]: any }) {
  const res = await request<any>('/api/payment/invite/records', {
    method: 'GET',
    ...(options || {}),
  });
  return unwrapData(res);
}
